import React, { useState } from "react";
import "./Dashboard.css";
import { useStateContext } from "../contexts/ContextProvider";
import General from "../components/aboutBox/General";
import Collaboration from "../components/aboutBox/Collaboration";

import NullBox from "../components/aboutBox/NullBox";
import Tools from "../components/aboutBox/Tools";
import {aboutData} from '../data/rawData';
import NoSlide from "../components/aboutBox/NoSlide";


import { motion } from "framer-motion";
import { Button } from "@mui/material";

// Define variants for animations
const fadeIn = {
  hidden: { opacity: 0 },
  visible: { opacity: 1, transition: { duration: 0.8 } },
};

const About = () => {
  const { activeMenu } = useStateContext(); // Access activeMenu state
  const [activeButton, setActiveButton] = useState(null); // Track active button index

  // Define content components for each button
  const contentMap = {
    General: <General />,
    Tools: <Tools />,
    Philosophy: <NoSlide data={aboutData.Philosophy} key={activeButton} />, // Use the imported data for Philosophy section
    Data_Design: <NoSlide data={aboutData.Data_Design} key={activeButton} />, // Use the imported data for Data_Design section
    Collaboration: <Collaboration />, // Use the imported data for Collaboration section
  };

  return (
    <div className="dashboard">
      <div id="base">
        {/* Page Content */}
        <div className="content">
          <div className="grid-container">
            {/* Top row with buttons */}
            <motion.div
              style={{
                gridColumn: "3 / span 12",
                gridRow: "2 / span 2",
                display: "flex",
                justifyContent: "space-around",
                alignItems: "center",
                padding: window.innerWidth < 1600 && window.innerHeight < 900 ? "0.5rem" : "1rem", // Reduce padding for smaller resolutions
              }}
              variants={fadeIn}
              initial="hidden"
              animate="visible"
            >
              {[
                "General",
                "Tools",
                "Philosophy",
                "Collaboration",
              ].map((text, index) => (
                <Button
                  key={index}
                  variant="outlined"
                  onClick={() => setActiveButton(index)} // Update active button index
                  className={`px-8 text-sm desktop1920:text-lg flex items-center ${
                    activeButton === index ? "active" : ""
                  }`}
                  sx={{
                    borderColor: activeButton === index
                      ? "transparent"
                      : "rgba(156, 163, 175, 0.5)",
                    borderWidth: "2px",
                    color: activeButton === index
                      ? "rgba(255, 255, 255, 1)"
                      : "rgba(156, 163, 175, 1)",
                    textTransform: "none",
                    transition: "all 0.3s ease",
                    background: activeButton === index
                      ? "linear-gradient(to right,rgba(128, 24, 231, 0.7),rgba(16, 185, 129, 0.7),rgba(59, 131, 246, 0.7))"
                      : "transparent",
                    "&:hover": {
                      borderWidth: "2px",
                      borderColor: "transparent",
                      borderImage:
                        "linear-gradient(to right, #8018e7, #10b981, #3b82f6) 1",
                      color: "rgba(255, 255, 255, 1)",
                    },
                  }}
                >
                  {text}
                </Button>
              ))}
            </motion.div>

            {/* Dynamic Content Area */}
            <motion.div
              style={{
                gridColumn: "3 / span 12",
                gridRow: "5 / span 14",
                borderColor: "rgba(156, 163, 175, 0.5)",
                borderWidth: "2px",
                borderStyle: "solid",
                transition: "all 0.3s ease",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "flex-start",
                minHeight: "300px", // Adjust height as needed
                textAlign: "center",
              }}
              variants={fadeIn}
              initial="hidden"
              animate="visible"
            >
              {activeButton !== null
                ? Object.values(contentMap)[activeButton]
                : <NullBox />}
            </motion.div>
          </div>
        </div>

        {/* Background Layers */}
        <div
          id="hey"
          className="w-full bg-[#011] absolute right-0 left-0 mx-auto z-10 transform perspective-[200px]
            desktop1280:bottom-[27.3vh] desktop1440:bottom-[28vh] 
            desktop1600:bottom-[28vh] desktop1920:bottom-[27vh]"
        >
          <div id="layer-up"></div>
        </div>

        <div
          id="layer-0"
          className={`${activeMenu ? "w-[calc(200vw-28rem)]" : "w-[200vw]"}`}
        >
          <div id="layer-1">
            <div id="layer-2">
              <div id="lines">
                <div id="layer-corner"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
